var $body, page;

$( function () {
    $body = $( 'body' );
} );

export { $body, page };
